import React, { useState, useEffect } from "react";
import {
  getProduct,
  deleteProduct,
  clearError,
  clearMessage,
} from "../redux/productSlice";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { FaCircleMinus } from "react-icons/fa6";
import { FaPlusCircle } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import ConfirmationModal from "../BaseFiles/ConfirmationModel";
import SellProductModal from "./SellProductModel";
import PurchaseProductModal from "./PurchaseProductModel";
export default function Products() {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [deletedID, setDeletedID] = useState(null);
  const [visible, setVisible] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [sellVisible, setSellVisible] = useState(null);
  const [purchaseVisible, setPurchaseVisible] = useState(null);
  const { loading, allproducts, error, message } = useSelector(
    (state) => state.products
  );

  useEffect(() => {
    dispatch(getProduct());
    if (error) {
      toast(error);
      setTimeout(() => {
        dispatch(clearError());
      }, 3000);
    }
    if (message) {
      toast(message);
      setTimeout(() => {
        dispatch(clearMessage());
      }, 3000);
    }
  }, [error, dispatch, message]);

  const filteredProducts = allproducts?.filter((product) =>
    product.productName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  function handleDelete(id) {
    setDeletedID(id);
    setVisible(true);
  }

  function CloseModel() {
    setDeletedID(null);
    setVisible(false);
    setSelectedProduct(null);
    setSellVisible(false);
    setPurchaseVisible(false);
  }

  function deletePro() {
    dispatch(deleteProduct(deletedID));
    CloseModel();
  }
  const handleSellProduct = (product) => {
    setSelectedProduct(product);
    setSellVisible(true);
  };
  const handlePurchaseProduct = (product) => {
    setSelectedProduct(product);
    setPurchaseVisible(true);
  };
  return (
    <>
    <div className="px-4 sm:px-6 lg:px-0">
      <ToastContainer/>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-gray-900">Producst</h1>
          <p className="mt-2 text-sm text-gray-700">
            A list of all the products in your account including their name,
            category,and other detail.
          </p>
        </div>
        <div className="flex mt-4 sm:ml-16 sm:mt-0 sm:flex-none gap-x-4">
          <input
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search Products"
            className="border p-2 rounded-full w-64"
          />
          <Link
            type="button"
            to={"/add/product"}
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Add products
          </Link>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Detail
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Price
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Stock
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Entry
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {filteredProducts?.map((product) => (
                  <tr key={product.email}>
                    <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                      <div className="flex items-center">
                        <div className="size-11 shrink-0">
                          <img
                            alt=""
                            src={`https://api-inventory.neuromotion.tech/images/${product.image}`}
                            className="size-11 rounded-full"
                          />
                        </div>
                        <div className="ml-4">
                          <div className="font-medium text-blue-900">
                            #{product.id}({product.category})
                          </div>
                          <div className="mt-1 text-gray-500">
                            {product.productName}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                      <div className="text-gray-900">
                        Color :{product.color}
                      </div>
                      <div className="mt-1 text-gray-500">
                        Size :{product.size}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                      <div className="text-gray-900">
                        Selling : {product.sellingPricePack}
                      </div>
                      <div className="mt-1 text-gray-500">
                        Purchasing :{product.purchasePricePack}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                        {product.packStock}.{product.unitStock} Qyt
                      </span>
                    </td>
                    <td className="flex gap-x-4 items-center whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                      <FaPlusCircle onClick={() => {handlePurchaseProduct(product)}} className="text-green-500 mt-3 text-2xl" />
                      {!Number(product.packStock) < 1 && (
                      <FaCircleMinus onClick={() => {handleSellProduct(product)}} className="text-blue-500 mt-3 text-2xl" />)}
                    </td>
                    <td className="whitespace-nowrap px-3 text-sm text-gray-500">
                        <div className="flex gap-x-4">
                   <Link to={`/edit/product/${product.id}`}><FaEdit  className="text-yellow-500 text-2xl" /></Link>
                    <MdDelete onClick={()=>handleDelete(product.id)} className="text-red-500 text-2xl" />
                    </div>
                    </td>
                   
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

{deletedID && (
  <ConfirmationModal
    visible={visible}
    onCancel={() => CloseModel()}
    onConfirm={() => deletePro()}
    message={"Are you sure want to Delete this Product"}
  />
)}
 {sellVisible && (
        <SellProductModal
          visible={sellVisible}
          onCancel={() => CloseModel()}
          product={selectedProduct}
        />
      )}
      {purchaseVisible && (
        <PurchaseProductModal
          visible={purchaseVisible}
          onCancel={() => CloseModel()}
          product={selectedProduct}
        />
      )}
</>
  );
}
